module.exports = __webpack_public_path__ + "static/img/want-2.7a91dcda.png";